module.exports = __webpack_public_path__ + "static/media/golf.0a7e6773.png";